import { OperatorType } from 'src/types';
export var compareByOperator = function compareByOperator(operator, a, b) {
  switch (operator) {
    case OperatorType.equal:
      return a == b;

    case OperatorType.notEqual:
      return a != b;

    case OperatorType.greaterThan:
      return a > b;

    case OperatorType.lessThan:
      return a < b;

    case OperatorType.greaterThanOrEqualTo:
      return a >= b;

    case OperatorType.lessThanOrEqualTo:
      return a <= b;
  }

  return a === b;
};